import React, { FC, ReactNode } from 'react'

interface ModalInfoProps {
  label: string
  value: ReactNode
}

const ModalInfo: FC<ModalInfoProps> = ({ label, value }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:gap-4 gap-1 text-sm sm:text-base font-medium ">
      <strong className="text-[#6C757D] min-w-max">{label}:</strong>
      <span className="text-left break-words">{value}</span>
    </div>
  )
}

export default ModalInfo
